<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  let bg_audio,that;
  /*import {Tabbar, TabbarItem,Icon, CountDown} from 'vant';*/
export default {
  name: 'App',
  components:{
    /*'van-tabbar':Tabbar,
    'van-tabbar-item':TabbarItem,
    'van-icon':Icon,
    'van-count-down':CountDown*/
  },
  data() {
    return {
      active: 0,
      bg_sound_status:false,
      bg_count:0,
      time: 30 * 60 * 60 * 1000,
    };
  },
  watch: {
    /*'$route' (to, from) { //监听路由是否变化
      // console.log(to,from);
      switch (to.name){
        case 'Activity':case 'Photo':case 'Lottery':this.active=1;break
        case 'Center':this.active=2;break;
        default:this.active=0;
      }
    }*/
  },
  created() {
    that=this;
    // localStorage.setItem('token','6ed4442893c9ea32c25740d3c8b4088f540c5d8c111e3da3be34fcb04b2db704')
    /*bg_audio=document.getElementById("audio_bg");
    if(!bg_audio.paused){
      that.bg_sound_status=true;
    }
    bg_audio.addEventListener('playing',function () {
      that.bg_sound_status=true;
    });
    bg_audio.addEventListener('pause',function () {
      that.bg_sound_status=false;
    });*/
    this.$http(this.$Global.url_base+'getData.php',{url:location.href.split('#')[0]},'POST').then(function (response) {
      /*console.log(response)*/
      var res=response.data;
      if(!res.status){
        that.$wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature,// 必填，签名
          jsApiList: ['showAllNonBaseMenuItem','hideAllNonBaseMenuItem','showMenuItems','hideMenuItems','updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline','onMenuShareAppMessage','scanQRCode','openAddress'] // 必填，需要使用的JS接口列表
        });
        that.$wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          that.$wx.hideAllNonBaseMenuItem();
          that.$wx.showMenuItems({
            menuList: [
              'menuItem:share:appMessage',
              'menuItem:share:timeline'
            ]
          });
          that.$wx.updateAppMessageShareData({
            title: '2025年全民健身社区运动会', // 分享标题
            desc: '现代五项大众障碍跑', // 分享描述
            /*link: 'http://gdnybank-shop.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致*/
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            /*imgUrl: 'https://h5storage.xingflash.com/picc_2025/images/share_img.png', // 分享图标*/
            imgUrl: 'https://h5storage.xingflash.com/modern_enroll_2024/images/share_img.png', // 分享图标
            success: function () {
              // 设置成功
            }
          });
          that.$wx.updateTimelineShareData({
            title: '2025年全民健身社区运动会 现代五项大众障碍跑', // 分享标题
            /*link: 'http://gdnybank-shop.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致*/
            link: location.href,
            imgUrl: 'https://h5storage.xingflash.com/modern_enroll_2024/images/share_img.png', // 分享图标
            success: function () {
              // 设置成功
            }
          });
        });
      }else{
        console.log(res.info);
      }
    }).catch(function (error) {
      console.log(error);
      /*Toast(error);*/
    });
    /*document.addEventListener('touchstart',()=>{
      if(this.bg_count<=0){
        bg_audio.play();
        this.bg_count=1;
      }
    });*/
  },
  methods:{
    bg_music(){
      if(bg_audio.paused){
        bg_audio.play();
      }else{
        bg_audio.pause();
        this.bg_count++;
      }
    },
    goOrderList(){
      this.$router.push('/orders.html');
    }
  }
}
</script>

<style>
:root{
  --home_logo: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_logo.png');
  --home_tit: url('https://chengma-competition-cdn.xingflash.com/modern_enroll_2026/images/home_tit.png');
  --home_icon: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_icon.png');
  --home_bg_top: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_bg_top.png');
  --home_bg_bot: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_bg_bot.png');
  --site_logo: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_logo.png');
  --site_btn_back: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_btn_back.png');
  --site_form_tit_bg: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_form_tit_bg.png');
  --enroll_disclaimer_1: url('https://chengma-competition-cdn.xingflash.com/modern_enroll_2026/images/enroll_disclaimer_1.png');
  --enroll_disclaimer_2: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_2.png');
  --enroll_disclaimer_3: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_3.png');
  --enroll_disclaimer_4: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_4.png');
  --enroll_disclaimer_5: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_5.png');
  --enroll_disclaimer_6: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_6.png');
  --enroll_disclaimer_7: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_7.png');
  --enroll_disclaimer_10: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_10.png');
  --enroll_disclaimer_11: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_11.png');
  --rank_tit: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_tit.png');
  --rank_cont_bg: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_cont_bg.png');
  --rank_cont_tip: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_cont_tip.png');
  --rank_num_1: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_1.png");
  --rank_num_2: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_2.png");
  --rank_num_3: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_3.png");
}
body{
  background-color: #f18e2e;
}
#app {
  min-height: 100vh;
  position: relative;
}
#app:before{
  content: " ";
  display: block;
  background: var(--home_bg_top) no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 6.07rem;
  position: absolute;
  left: 0;
  top: 0;
}
#app:after{
  content: " ";
  display: block;
  background: var(--home_bg_bot) no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 3.25rem;
  position: absolute;
  left: 0;
  bottom: 0;
}
.container{
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue